{
  "nav": {
    "inicio": "Home",
    "contacto": "Contact",
    "pago": "Payment"
  },
  "common": {
    "loading": "Loading...",
    "error": "An error has occurred",
    "back": "Back",
    "close": "Close",
    "more_info": "More information"
  }
}
